import dayjs from "dayjs";
import localization from "dayjs/locale/es";

/**
 * Formats a number by including dots and commas.
 * @param number Plain-format number that wants to be converted.
 * @returns The provided number as formatted string.
 */
export function formatNumber(number: number): string {
  const converterRegex = /(\d)(?=(\d{3})+(?!\d))/g;

  const parsedNumber = Math.floor(number).toString();

  return parsedNumber.replace(converterRegex, "$1.");
}

/**
 * Rounds a number given a no. of decimals.
 * @param value - The number to round.
 * @param decimals - How many decimals the result should include.
 * Default is 0.
 */
export function roundNumber(value: number, decimals: number | undefined = 0) {
  if (decimals < 0) return value;

  return Number(
    Math.round(parseFloat(value + "e" + decimals)) + "e-" + decimals
  );
}

/**
 * Formats a date with ES / DD-MM-YY format.
 * @param date - Date to format.
 * @returns - Formatted date.
 */
export function formatDate(
  date: Date,
  format: string | undefined = "DD-MM-YY"
): string {
  const formattedDate = dayjs(date).locale("es", localization).format(format);

  return formattedDate;
}
